import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconEraseV2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.21474 9.14842C1.13215 9.06581 1.13215 8.93188 1.21476 8.84928L3.52651 6.53753L8.37914 11.3902L6.88609 13.0309C6.84601 13.0749 6.78921 13.1 6.72965 13.1L5.25319 13.1001L5.25322 13.4969L5.25319 13.1001C5.19708 13.1001 5.14326 13.0778 5.10358 13.0382L1.21474 9.14842Z",
		stroke: "#959595",
		strokeWidth: .8
	}), /* @__PURE__ */ _jsx("rect", {
		x: 3.52734,
		y: 5.9718,
		width: 8.44514,
		height: 7.64425,
		transform: "rotate(-45 3.52734 5.9718)",
		fill: "#959595"
	})]
});
export default SvgIconEraseV2;
